/* eslint-disable max-lines-per-function */ "use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "lightColors", {
    enumerable: true,
    get: ()=>lightColors
});
const _merge = /*#__PURE__*/ _interopRequireDefault(require("lodash/merge"));
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const lightColors = (colors, overrides)=>(0, _merge.default)({
        range_bar: {
            dots_unreached: colors.grayDark,
            unfilled_track: colors.grayDark,
            dots_text: colors.black,
            dots_reached: colors.primary,
            filled_track: colors.primary
        },
        sub_navigation: {
            icon: colors.primary,
            background: colors.light,
            text: colors.primary
        },
        top_navigation: {
            icon: colors.primary,
            background: colors.light,
            divider: colors.gray,
            text: colors.primary
        },
        bottom_navigation: {
            background: colors.primary,
            border: colors.secondary,
            active_icon_color: colors.secondary,
            inactive_icon_color: colors.white
        },
        item_card: {
            box_background: colors.white,
            box_border: colors.white,
            box_paragraph_text: colors.black,
            heart_filled_icon_color: colors.red,
            heart_empty_icon_color: colors.red,
            star_icon_color: colors.primary
        },
        form: {
            input_label: colors.black,
            input_text: colors.black,
            input_background: colors.light,
            input_border: colors.gray,
            input_placeholder: colors.gray,
            input_checkbox_background: colors.secondary,
            input_checkbox_border: colors.light,
            input_checkbox_icon: colors.primary
        },
        auth: {
            background: colors.white,
            text: colors.black,
            pad_placeholder: colors.gray,
            pad_text: colors.black,
            icon: colors.primary,
            signature_background: colors.light,
            signature_text: colors.white
        },
        profile: {
            text: colors.black,
            icon: colors.primary
        },
        menu: {
            background: colors.white,
            icon: colors.primary,
            card_background: colors.light,
            card_text: colors.black,
            card_border: colors.light
        },
        store: {
            text: colors.black,
            background: colors.white,
            link_text: colors.black,
            link_border: colors.gray,
            link_background: colors.white
        },
        offers: {
            icon: colors.primary,
            text: colors.black,
            button_earn_background: colors.white,
            button_earn_text: colors.primary
        },
        rewards: {
            text: colors.black
        },
        milestones: {
            text: colors.black,
            icon: colors.primary
        },
        subscriptions: {
            text: colors.black,
            icon: colors.primary
        },
        subs_pop_ups: {
            text: colors.white,
            icon: colors.primary,
            background: colors.primary,
            background_warning: colors.danger,
            button_background: colors.primary,
            button_background_warning: colors.white,
            button_text: colors.white,
            button_text_warning: colors.danger
        },
        gift_card: {
            card_color: colors.primary,
            card_color_muted: colors.secondary,
            card_text_color: colors.white,
            icon: colors.white
        },
        messages: {
            text: colors.black,
            icon: colors.light,
            slider_counter_background: colors.gray,
            slider_counter: colors.white,
            slider_dots_background: colors.gray,
            slider_dots: colors.white,
            link_box_border: colors.primary,
            link_box_background: colors.white,
            link_box_icon_background: colors.primary,
            link_box_icon: colors.primary
        },
        refer: {
            icon: colors.primary,
            qr_code_background: colors.white,
            qr_code_color: colors.black,
            text: colors.black,
            social_facebook_icon_color: '#3b5998',
            social_twitter_icon_color: '#000000',
            social_linkedin_icon_color: '#0077b5',
            social_instagram_icon_color: '#e4405f'
        },
        general: {
            link: colors.primary,
            text: colors.black,
            divider: colors.gray,
            spinner_background: colors.primary,
            spinner_icon: colors.white,
            screen_background: colors.white,
            section_background: colors.light,
            button_background: colors.primary,
            button_text: colors.white,
            button_neutral_background: colors.light,
            button_neutral_text: colors.primary,
            button_danger_background: colors.red,
            button_danger_text: colors.white
        },
        account_history: {
            text: colors.black,
            icon: colors.primary,
            active_button_background: colors.primary,
            active_button_text: colors.white,
            inactive_button_background: colors.light,
            inactive_button_text: colors.black
        },
        account_information: {
            icon: colors.primary
        },
        account_settings: {
            text: colors.black,
            swipe_active_background: colors.primary,
            swipe_inactive_background: colors.light,
            thumb_active_background: colors.white,
            thumb_inactive_background: colors.white
        },
        modal: {
            text: colors.black,
            icon: colors.primary,
            overlay_background: colors.transparencyLight,
            background: colors.white,
            header_background: colors.light,
            body_background: colors.white,
            footer_background: colors.light,
            button_background: colors.primary,
            button_text: colors.white,
            button_icon: colors.white
        }
    }, overrides);
